var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "bg-FF p-16 m-b-12 b-r-8" },
      [
        _c(
          "div",
          { staticClass: "flex space-between col-center m-b-20" },
          [
            _c("TitleLogo"),
            _c("span", { staticClass: "font-32 font-weight-500" }, [
              _vm._v("核心表现概览"),
            ]),
          ],
          1
        ),
        _vm.roleType != 13
          ? [
              _c("div", { staticClass: "flex row-between col-center m-b-20" }, [
                _c(
                  "div",
                  {
                    staticClass: "width-30 b-r-8 p-16 text-center",
                    style: _vm.getBackgroundStyle("attendanceUrl"),
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "font-32 font-weight-600 m-b-8" },
                      [_vm._v(_vm._s(_vm.boardData.kqsj?.attendanceRate) + "%")]
                    ),
                    _c("div", { staticClass: "font-24 m-b-32" }, [
                      _vm._v("出勤率"),
                    ]),
                    _c("div", { staticClass: "flex-col flex-gap-4 font-24" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "b-r-45 bg-B1FFE7 p-t-8 p-b-8 p-l-16 p-r-16",
                        },
                        [
                          _vm._v(
                            "团队第" +
                              _vm._s(_vm.boardData.kqsj?.attendanceSort) +
                              "名"
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          class:
                            _vm.boardData.kqsj?.attendanceRate >
                            _vm.boardData.kqsj?.averageRate
                              ? "cor-00B719"
                              : "cor-FE4C4E",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.boardData.kqsj?.attendanceRate >
                                  _vm.boardData.kqsj?.averageRate
                                  ? "高于"
                                  : "低于"
                              ) +
                              "均值 "
                          ),
                          _vm.boardData.kqsj
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      Number(
                                        Math.abs(
                                          _vm.boardData.kqsj?.attendanceRate -
                                            _vm.boardData.kqsj?.averageRate
                                        ).toFixed(0)
                                      )
                                    ) +
                                    "% "
                                ),
                              ])
                            : _c("span", [_vm._v("-%")]),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "width-30 b-r-8 p-16 text-center",
                    style: _vm.getBackgroundStyle("performanceUrl"),
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "font-32 font-weight-600 m-b-8" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.boardData.performance.proportion
                              ? _vm.boardData.performance.proportion
                              : "-"
                          )
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "font-24 m-b-32" }, [
                      _vm._v("平均绩效分"),
                    ]),
                    _c("div", { staticClass: "flex-col flex-gap-4 font-24" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "b-r-45 bg-FFE8AF p-t-8 p-b-8 p-l-16 p-r-16",
                        },
                        [
                          _vm._v(
                            "团队第" +
                              _vm._s(
                                _vm.boardData.performance?.ranking == 0
                                  ? "-"
                                  : _vm.boardData.performance?.ranking
                              ) +
                              "名"
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          class:
                            _vm.boardData.performance?.proportion >
                            _vm.boardData.performance?.mean
                              ? "cor-00B719"
                              : "cor-FE4C4E",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.boardData.performance?.proportion >
                                  _vm.boardData.performance?.mean
                                  ? "高于"
                                  : "低于"
                              ) +
                              "均值 "
                          ),
                          _vm.boardData.performance
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      Number(
                                        Math.abs(
                                          _vm.boardData.performance
                                            ?.proportion -
                                            _vm.boardData.performance?.mean
                                        ).toFixed(0)
                                      )
                                    ) +
                                    "分 "
                                ),
                              ])
                            : _c("span", [_vm._v("-分")]),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "width-30 b-r-8 p-16 text-center",
                    style: _vm.getBackgroundStyle("feedbackUrl"),
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "font-32 font-weight-600 m-b-8" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.boardData.feedback?.proportion == 0
                              ? "-"
                              : _vm.boardData.feedback?.proportion
                          ) + "%"
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "font-24 m-b-32" }, [
                      _vm._v("及时反馈率"),
                    ]),
                    _c("div", { staticClass: "flex-col flex-gap-4 font-24" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "b-r-45 bg-A4B7FF p-t-8 p-b-8 p-l-16 p-r-16",
                        },
                        [
                          _vm._v(
                            "团队第" +
                              _vm._s(
                                _vm.boardData.feedback?.ranking == 0
                                  ? "-"
                                  : _vm.boardData.feedback?.ranking
                              ) +
                              "名"
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          class:
                            _vm.boardData.feedback?.proportion >
                            _vm.boardData.feedback?.mean
                              ? "cor-00B719"
                              : "cor-FE4C4E",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.boardData.feedback?.proportion >
                                  _vm.boardData.feedback?.mean
                                  ? "高于"
                                  : "低于"
                              ) +
                              "均值 "
                          ),
                          _vm.boardData.feedback
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      Number(
                                        Math.abs(
                                          _vm.boardData.feedback?.proportion -
                                            _vm.boardData.feedback?.mean
                                        ).toFixed(0)
                                      )
                                    ) +
                                    "% "
                                ),
                              ])
                            : _c("span", [_vm._v("-%")]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._l(_vm.boardData.hthk, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "flex col-center m-b-20 p-16 bg-F5F9FF b-r-8",
                  },
                  [
                    _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
                      item.type == 1
                        ? _c("img", {
                            staticClass: "width-100 height-100",
                            attrs: {
                              alt: "合同",
                              src: require("@/assets/icon/employeeKanban/contract.png"),
                            },
                          })
                        : _vm._e(),
                      item.type == 2
                        ? _c("img", {
                            staticClass: "width-100 height-100",
                            attrs: {
                              alt: "回款",
                              src: require("@/assets/icon/employeeKanban/revenue.png"),
                            },
                          })
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "width-90" }, [
                      _c("div", { staticClass: "font-28 m-b-8" }, [
                        _c("span", { staticClass: "font-28" }, [
                          _vm._v(
                            _vm._s(item.type == 1 ? "合同签订" : "回款金额") +
                              "： "
                          ),
                          _c(
                            "span",
                            { staticClass: "font-40 font-weight-700" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item.amount == 0
                                      ? "-"
                                      : Number(
                                          parseFloat(item.amount) / 10000
                                        ).toFixed(2)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "font-24" }, [
                            _vm._v("万元"),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "text-right font-24" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "dis-in-b h-44 l-h-44 p-l-20 p-r-20 m-r-8 b-r-90",
                            style: {
                              border: `1px solid ${
                                item.type == 1 ? "#f7b700" : "#36CE87"
                              }`,
                            },
                          },
                          [
                            _vm._v(
                              "贡献率" +
                                _vm._s(item.rate == 0 ? "-" : item.rate) +
                                "%"
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticClass:
                              "dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r b-r-90",
                            style: {
                              border: `1px solid ${
                                item.type == 1 ? "#f7b700" : "#36CE87"
                              }`,
                            },
                          },
                          [
                            _vm._v(
                              "团队第" +
                                _vm._s(item.ranking == 0 ? "-" : item.ranking) +
                                "名"
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                )
              }),
            ]
          : [
              _c(
                "div",
                { staticClass: "flex col-center m-b-20 p-16 bg-F5F9FF b-r-8" },
                [
                  _vm._m(0),
                  _c("div", { staticClass: "width-90" }, [
                    _c("div", { staticClass: "font-28 m-b-8" }, [
                      _c("span", { staticClass: "font-28" }, [
                        _vm._v("出勤率： "),
                        _c("span", { staticClass: "font-40" }, [
                          _c("span", { staticClass: "font-weight-700" }, [
                            _vm._v(_vm._s(_vm.boardData.kqsj?.attendanceRate)),
                          ]),
                          _vm._v("% "),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "text-right font-24" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r b-r-90 m-r-8",
                          staticStyle: { border: "1px solid #85F3D1" },
                        },
                        [
                          _vm._v(
                            "团队第" +
                              _vm._s(_vm.boardData.kqsj?.attendanceSort) +
                              "名"
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r-90",
                          class:
                            _vm.boardData.kqsj?.attendanceRate >
                            _vm.boardData.kqsj?.averageRate
                              ? "cor-00B719"
                              : "cor-FE4C4E",
                          staticStyle: { border: "1px solid #85F3D1" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.boardData.kqsj?.attendanceRate >
                                  _vm.boardData.kqsj?.averageRate
                                  ? "高于"
                                  : "低于"
                              ) +
                              "均值 "
                          ),
                          _vm.boardData.kqsj
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      Number(
                                        Math.abs(
                                          _vm.boardData.kqsj?.attendanceRate -
                                            _vm.boardData.kqsj?.averageRate
                                        ).toFixed(0)
                                      )
                                    ) +
                                    "% "
                                ),
                              ])
                            : _c("span", [_vm._v("-%")]),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "flex col-center m-b-20 p-16 bg-F5F9FF b-r-8" },
                [
                  _vm._m(1),
                  _c("div", { staticClass: "width-90" }, [
                    _c("div", { staticClass: "font-28 m-b-8" }, [
                      _c("span", { staticClass: "font-28" }, [
                        _vm._v("平均绩效分： "),
                        _c("span", { staticClass: "font-40" }, [
                          _c("span", { staticClass: "font-weight-700" }, [
                            _vm._v(
                              _vm._s(
                                _vm.boardData.performance.proportion
                                  ? _vm.boardData.performance.proportion
                                  : "-"
                              )
                            ),
                          ]),
                          _vm._v("% "),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "text-right font-24" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r b-r-90 m-r-8",
                          staticStyle: { border: "1px solid #F7B700" },
                        },
                        [
                          _vm._v(
                            "团队第" +
                              _vm._s(
                                _vm.boardData.performance?.ranking == 0
                                  ? "-"
                                  : _vm.boardData.performance?.ranking
                              ) +
                              "名"
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r-90",
                          class:
                            _vm.boardData.performance?.proportion >
                            _vm.boardData.performance?.mean
                              ? "cor-00B719"
                              : "cor-FE4C4E",
                          staticStyle: { border: "1px solid #F7B700" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.boardData.performance?.proportion >
                                  _vm.boardData.performance?.mean
                                  ? "高于"
                                  : "低于"
                              ) +
                              "均值 "
                          ),
                          _vm.boardData.performance
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      Number(
                                        Math.abs(
                                          _vm.boardData.performance
                                            ?.proportion -
                                            _vm.boardData.performance?.mean
                                        ).toFixed(0)
                                      )
                                    ) +
                                    "分 "
                                ),
                              ])
                            : _c("span", [_vm._v("-分")]),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "flex col-center m-b-20 p-16 bg-F5F9FF b-r-8" },
                [
                  _vm._m(2),
                  _c("div", { staticClass: "width-90" }, [
                    _c("div", { staticClass: "font-28 m-b-8" }, [
                      _c("span", { staticClass: "font-28" }, [
                        _vm._v("及时反馈率： "),
                        _c("span", { staticClass: "font-40" }, [
                          _c("span", { staticClass: "font-weight-700" }, [
                            _vm._v(
                              _vm._s(
                                _vm.boardData.feedback?.proportion == 0
                                  ? "-"
                                  : _vm.boardData.feedback?.proportion
                              )
                            ),
                          ]),
                          _vm._v("% "),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "text-right font-24" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r b-r-90 m-r-8",
                          staticStyle: { border: "1px solid #A4B7FF" },
                        },
                        [
                          _vm._v(
                            "团队第" +
                              _vm._s(
                                _vm.boardData.feedback?.ranking == 0
                                  ? "-"
                                  : _vm.boardData.feedback?.ranking
                              ) +
                              "名"
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "dis-in-b h-44 l-h-44 p-l-20 p-r-20 b-r-90",
                          class:
                            _vm.boardData.feedback?.proportion >
                            _vm.boardData.feedback?.mean
                              ? "cor-00B719"
                              : "cor-FE4C4E",
                          staticStyle: { border: "1px solid #A4B7FF" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.boardData.feedback?.proportion >
                                  _vm.boardData.feedback?.mean
                                  ? "高于"
                                  : "低于"
                              ) +
                              "均值 "
                          ),
                          _vm.boardData.feedback
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      Number(
                                        Math.abs(
                                          _vm.boardData.feedback?.proportion -
                                            _vm.boardData.feedback?.mean
                                        ).toFixed(0)
                                      )
                                    ) +
                                    "% "
                                ),
                              ])
                            : _c("span", [_vm._v("-%")]),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
            ],
      ],
      2
    ),
    _c("div", { staticClass: "bg-FF b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center p-t-16 p-l-16 p-r-16" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("考勤统计"),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "flex flex-wrap p-b-20" }, [
        _c(
          "div",
          {
            staticClass:
              "m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
            staticStyle: { width: "45.4%" },
          },
          [
            _vm._m(3),
            _c("div", [
              _c("div", { staticClass: "font-40 font-weight-700" }, [
                _vm._v(_vm._s(_vm.boardData.kqsj?.cdcs)),
              ]),
              _c("div", { staticClass: "font-24" }, [_vm._v("迟到次数")]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
            staticStyle: { width: "45.4%" },
          },
          [
            _vm._m(4),
            _c("div", [
              _c("div", { staticClass: "font-40 font-weight-700" }, [
                _vm._v(_vm._s(_vm.boardData.kqsj?.ztcs)),
              ]),
              _c("div", { staticClass: "font-24" }, [_vm._v("早退次数")]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
            staticStyle: { width: "45.4%" },
          },
          [
            _vm._m(5),
            _c("div", [
              _c("div", { staticClass: "font-40 font-weight-700" }, [
                _vm._v(_vm._s(_vm.boardData.kqsj?.leaveDays)),
              ]),
              _c("div", { staticClass: "font-24" }, [_vm._v("请假次数")]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
            staticStyle: { width: "45.4%" },
          },
          [
            _vm._m(6),
            _c("div", [
              _c("div", { staticClass: "font-40 font-weight-700" }, [
                _vm._v(_vm._s(_vm.boardData.kqsj?.kgcs)),
              ]),
              _c("div", { staticClass: "font-24" }, [_vm._v("旷工次数")]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "出勤率",
          src: require("@/assets/icon/employeeKanban/caiwu/cql.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "平均绩效分",
          src: require("@/assets/icon/employeeKanban/caiwu/jxf.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "及时反馈率",
          src: require("@/assets/icon/employeeKanban/caiwu/fkl.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "迟到",
          src: require("@/assets/icon/employeeKanban/late.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "早退",
          src: require("@/assets/icon/employeeKanban/early.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "请假",
          src: require("@/assets/icon/employeeKanban/leave.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "旷工",
          src: require("@/assets/icon/employeeKanban/absent.png"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }